module.exports = __webpack_public_path__ + "img/Settings.af29929b.svg";